// Layout.js
import React, { useEffect } from "react";
import Navigation from "../components/Navigation";
import ProgressStepper from "../components/ProgressStepper";
import MobileNavigation from "../components/MobileNavigation";
import "./css/PageLayout.css";
import { Outlet, useParams, useLocation } from "react-router-dom";


const Layout = () => {
  const { sessionId } = useParams();
  const location = useLocation();
  
  // Scroll to top when route changes
  useEffect(() => {
    // Scroll window to top
    window.scrollTo(0, 0);
    // Also scroll the root element if it's scrollable
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.scrollTop = 0;
    }
  }, [location.pathname]);
  
  // Show stepper only on editor pages, not on landing page
  const showStepper = location.pathname !== '/' && 
                      !location.pathname.includes('/login') && 
                      !location.pathname.includes('/signup') &&
                      !location.pathname.includes('/dashboard');

  // Add class when on landing page (no sidebar needed)
  const isLandingPage = location.pathname === '/';
  
  // Add class when on auth pages (no sidebar needed)
  // Dashboard/settings pages now show the menu
  const isAuthPage = location.pathname.includes('/auth/');
  const noSidebar = isLandingPage || isAuthPage;

  return (
    <div className={`app-container ${noSidebar ? 'no-sidebar' : ''}`}>
      <Navigation />
      <div className="content">
        {showStepper && <ProgressStepper sessionId={sessionId} />}
        <Outlet />
      </div>
      {showStepper && <MobileNavigation />}
    </div>
  );
};

export default Layout;
